import React, { useEffect, useRef, useState } from 'react'
import DatePicker from "react-datepicker";
import { createOrUpdateBillSummaryApi, generateBillingSummaryApi, getSiteBillSummaryApi } from '../../../utils/ApiEndpointFunctions';
import { useFormik } from 'formik';
import { billingSummaryInitalValue, billingSummaryValidationSchema, } from '../../../utils/Validation';
import Spinwheel from '../../../components/common/Spinwheel';
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams, useSearchParams, } from 'react-router-dom';
import ConfirmationModal from '../../../components/modal/ConfirmationModal';
import { useUserContext } from '../../../context/userContext';
import StatusModal from '../../../components/modal/StatusModal';
import * as XLSX from 'xlsx-js-style';


function CreateOrUpdateFinalBill() {
  const [addLoader, setAddLoader] = useState(false)
  const [loading, setLoading] = useState(false)
  const submitConfirmModal = "submitConfirmModal1"
  // const saveAndUploadConfirmModal = "saveAndUploadConfirmModalId"
  const reUploadConfirmModal = "reUploadConfirmModalId"
  const statusModalId = "statusModal1"
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams()
  const { id } = params;
  const { userDetails, langPreference } = useUserContext();
  const [confirmationMsg, setConfirmationMsg] = useState('');
  const location = useLocation();
  const [isUpload, setUpload] = useState(false)
  const fileRef = useRef()


  const handleSelectDate = (e, eleType) => {
    billingFormik.setFieldValue(eleType, new Date(e).toISOString())
  };


  const handleFormSubmit = async (values) => {
    try {
      setAddLoader(true)
      let payload = {
        _id: id,
        items: values?.items,
        billDate: values?.billDate,
        billSummaryNumber: values?.billSummaryNumber || "",
        billType: values?.billType,
        netAmt:values?.netAmt,
        netQty:values?.netQty,
        raBillNo:values?.raBillNo
      }
      const res = await createOrUpdateBillSummaryApi({ ...payload, type: "submit" });
      if (res.status === 200) {
        toast.success(res.data.message);
        document.getElementById(submitConfirmModal).click()
        setConfirmationMsg(res?.data?.message || `BOQ ${res.data?.data?.boqNumber || ""} is successfully submitted.`)
        document.getElementById('statusModalBtn').click()
      }
    } catch (error) {
      error && error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("something went wrong");
    }
    setAddLoader(false)
  }

  const billingFormik = useFormik({
    initialValues: billingSummaryInitalValue,
    onSubmit: handleFormSubmit,
    validationSchema: billingSummaryValidationSchema(langPreference),
  })


  const handleConfirmation = () => {
    billingFormik.handleSubmit();
  }

  const checkValidation = (btn) => {
    const errors = Object.keys(billingFormik.errors)
    if (errors?.length > 0) {
      billingFormik.handleSubmit()
    } else {
      document.getElementById(btn).click()
    }
  }

  const handleApprovalModalClose = () => {
    navigate(`/billing?tab=${searchParams?.get("tab")}&type=final-bill`)
  }


  const handleChange = (e, index, item, type) => {
    const { name, value } = e?.target
    if (isNaN(Number(value)) && type == "number") {
      return
    }

    billingFormik.handleChange(e)
    billingFormik.handleBlur(e)

    if (item && (name?.includes("withHoldQty"))) {
      let { withHoldQty = 0, quantity = 0, unitPrice = 0 } = item
      let netQty = quantity && value ? Number(quantity) - Number(value) : 0
      let netAmt = quantity && unitPrice ? Number(unitPrice) * Number(netQty) : 0
      billingFormik.setFieldValue(`items[${index}].netQty`, Number(netQty).toFixed(2))
      billingFormik.setFieldValue(`items[${index}].netAmt`, Number(netAmt).toFixed(2))
    }
  }


  const handleGenerateSummary = async (boqItemList) => {
    try {
      setUpload(true)
      if(boqItemList?.length==0){
        toast.error(langPreference?.data_not_found || "Data not found")
        setUpload(false)
        return
      }
      const result = await generateBillingSummaryApi({id,boqItemList, billType: searchParams.get('tab') });
      if (result.status === 200) {
        billingFormik.resetForm()
        toast.success(result.data.message);
        const data = result?.data?.data?.data
        const updatedList = data?.map(ele => {
          let withHoldQty = 0
          let { quantity, unitPrice } = ele
          console.log(quantity, unitPrice, "unitprice");

          let netQty = quantity ? +Number(Number(quantity) - Number(withHoldQty)).toFixed(2) : 0
          let netAmt = quantity && unitPrice ? Number(Number(unitPrice) * Number(netQty)).toFixed(2) : 0
          return {
            ...ele,
            withHoldQty,
            netAmt,
            netQty,
            _id: null
          }
        })
        billingFormik.setFieldValue("items", updatedList)
        billingFormik.setFieldValue("billType", searchParams.get('tab'))
      }
    } catch (error) {
      console.log("handleGenerateSummary error", error);
      error && error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("something went wrong");
    }
    setUpload(false)
  }

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const fileSplitArr = file?.name?.split(".")
      const fileExtension = fileSplitArr?.[fileSplitArr?.length - 1]
      const allowedExtensions = ['xlsx', 'xls']

      if (!allowedExtensions?.includes(fileExtension)) {
        toast.error(`Only xlsx, xls file allow`);
        return
      }

      if (file) {
        setUpload(true)
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const rawRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          const headerRowIndex = rawRows.findIndex(row => row?.includes("S.No.") && row?.includes("Item Description"));
          const jsonData = headerRowIndex >= 0 ? XLSX.utils.sheet_to_json(worksheet, { range: headerRowIndex }) : [];

          if (jsonData?.length == 0) {
            fileRef.current.value = null
            setUpload(false)
            toast.error(`Data not found`);
          }

          // Extract relevant columns
          let boqItemList = {}
          let boqNo = null
          for (const [index, row] of jsonData.entries()) {
            const sNo = row["S.No."];
            const itemDescription = row["Item Description"];
            const no1 = row["No"];
            const no2 = row["No"];
            const length = row["L"];
            const breadth = row["B"];
            const height = row["H"];
            const diameter = row["D"];
            const qty = row["QTY"];
            const remarks = row["Remarks"]
            const vendorId = row["Vendor ID"];
            const uniqueItemId = row["Item ID"];


            // Add valid row to filtered data
            if (String(sNo || "").includes("/")) {
              boqNo = String(sNo).split("/")?.[1]
              if (!boqItemList[boqNo]) {
                boqItemList[boqNo] = { itemDescription, dprItem: [], total: 0 }
              }
            } else if (searchParams.get('tab') === "subcontractor" && vendorId && uniqueItemId) {
              boqNo = `${vendorId}:${uniqueItemId}`
              if (!boqItemList[boqNo]) {
                boqItemList[boqNo] = { sNo, vendorId, uniqueItemId, itemDescription, dprItem: [], total: 0 }
              }
            }

            if (boqNo && (no1 && no2 && ((length && breadth && height) || (height && diameter)) && qty)) {
              boqItemList[boqNo] = {
                ...boqItemList[boqNo],
                dprItem: [...boqItemList[boqNo]?.dprItem, { no1, no2, length, breadth, height, diameter, qty, remarks }]
              }
            }

            if (boqNo && itemDescription?.toLowerCase() == "total") {
              boqItemList[boqNo] = {
                ...boqItemList[boqNo],
                total: boqItemList[boqNo]?.total + Number(qty)
              }
              boqNo = null
            }
          }

          let listItem = []
          for (const key in boqItemList) {
            const item = boqItemList[key]
            listItem.push({
              sNo: item?.uniqueItemId ? item?.sNo : key,
              vendorId: item?.vendorId,
              uniqueItemId: item?.uniqueItemId,
              itemDescription: item?.itemDescription,
              totalQty: item?.total
            })
          }
          handleGenerateSummary(listItem)
        };
        reader.readAsArrayBuffer(file);
      }

    } catch (error) {
      fileRef.current.value = null
      console.log("error", error);
      toast.error("Failed to upload")
    }
    setUpload(false)
  }

  const getBillingSummaryDetails = async () => {
    setLoading(true)
    try {
      let billType = searchParams?.get("tab")
      const { data } = await getSiteBillSummaryApi(id,billType)

      if (data?.data[0]) {
        billingFormik.setValues(data?.data[0])
        setSearchParams({ tab: searchParams.get('tab') })
      }
      setLoading(false)
    } catch (error) {
      console.log("handleGenerateSummary error", error);
      error && error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("something went wrong");
    }
  }

  useEffect(() => {
    let tab = searchParams?.get("tab")
    billingFormik.setFieldValue("billType", tab)
    if(id){
      getBillingSummaryDetails()
    }
  }, [searchParams?.get("tab")])

  return (
    <>
      {loading ? <div className='d-flex align-items-center justify-content-center'><Spinwheel /></div> : <>
        <div>
          <div className="dash-nav1">
            <div className="align-items-center d-block d-lg-flex justify-content-between">
              <div className="back"><span onClick={() => navigate(location?.state?.path ? location?.state?.path : -1, { state: { ...location?.state } })} className="back cursor-pointer" ><i className="bi bi-chevron-left"></i> {langPreference?.back || "Back"}</span></div>
              <h3 className="mb-0 font-blue">{langPreference?.generate_final_bill || "Generate Final Bill"} </h3>
              <div>
                <button type="button" disabled={addLoader} className="mb-2 mb-sm-2 sbm-purchase" onClick={() => {
                  if (billingFormik.values?.items?.length) {
                    checkValidation("submitModalBtn1")
                  } else toast.error(langPreference?.please_add_items || "Please add items")
                }}>
                  {addLoader ? <Spinwheel sizeClass={"spin-small"} /> : langPreference?.submit_for_approval || "Submit for approval"}
                </button>
              </div>
            </div>
          </div>
          <div className="dash-table">
            <div className="container">
              <div className="row gap-3 gap-xl-0">
                <div className="col-12">
                  <div className="">
                    <div className='d-flex align-items-center justify-content-between bb'>
                    </div>
                    <div>
                    </div>
                    <>
                      <h5>{langPreference?.bill_details || "Bill Details"}</h5>
                      <div className="form-details">
                        <div className="">
                          <div className='row row-cols-3'>
                            <div className="d-flex flex-column">
                              <label htmlFor="billDate">{langPreference?.company_name || "Company Name"}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`companyName`}
                                value={userDetails?.siteId?.companyId?.name}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <label htmlFor="siteName">{langPreference?.site_name || "Site Name"}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`siteName`}
                                value={userDetails?.siteId?.name}
                                disabled={true}
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <label htmlFor="billDate">{langPreference?.bill_date || "Bill Date"}</label>
                              <DatePicker dateFormat="dd/MM/yyyy" placeholderText='Bill Date' className='form-select cursor-pointer' name='billDate' selected={billingFormik.values?.billDate} onChange={(e) => { handleSelectDate(e, "billDate") }} />
                              <span id="billDate"></span>
                            </div>
                            <div className="d-flex flex-column">
                              <label htmlFor="raBillNo">{langPreference?.ra_bill_no || "RA Bill No"}</label>
                              <input
                                type="text"
                                className="form-control"
                                name={`raBillNo`}
                                value={billingFormik?.values?.raBillNo}
                                onChange={billingFormik?.handleChange}
                                onBlur={billingFormik?.handleBlur}
                              />
                              {billingFormik?.touched?.raBillNo && billingFormik?.errors?.raBillNo ? (<div className='req-error'>{billingFormik?.errors?.raBillNo}</div>) : null}
                            </div>
                            <div className="d-flex flex-column">
                              <label htmlFor="billType">{langPreference?.billing_type || "Billing Type"}</label>
                              <select className="form-select" name='billType' disabled={true} aria-label="Default select example" value={billingFormik?.values?.billType} onChange={billingFormik?.handleChange} >
                                <option value="">---</option>
                                <option value="client">Client</option>
                                <option value="subcontractor">Sub-contractor</option>
                              </select>
                              {billingFormik?.touched?.billType && billingFormik?.errors?.billType ? (<div className='req-error'>{billingFormik?.errors?.billType}</div>) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='mb-3  border-0 m-0 p-0' >
                        {/* First Row: Basic Details */}
                        <div className='w-100 mt-1'>
                          <div className='d-flex justify-content-between'>
                            <h3 className="mb-0 font-blue">
                              {langPreference?.bill_summary || "Bill summary"}
                            </h3>
                            <button type="button" className="add-vendor mb-sm-0 mb-sm-2" onClick={(e) => {
                              if (!isUpload) {
                                fileRef.current.value = null
                                if (billingFormik?.values?.items?.length) {
                                  document.getElementById("reUploadConfirmModal").click()
                                } else {
                                  fileRef.current.click()
                                }
                              }
                            }} >
                              {isUpload ? <Spinwheel sizeClass={"spin-small"} /> : langPreference?.upload || "Upload"}
                            </button>
                            <input type='file' accept=".xlsx, .xls" style={{ display: 'none' }} ref={fileRef} disabled={isUpload} onChange={(e) => { !isUpload && handleFileUpload(e) }} />
                          </div>
                          <div className="">
                            <table className="table d-table mt-4" style={{ position: 'relative' }} >
                              <thead style={{ position: 'sticky', top: '75px', backgroundColor: '#fbfbfb' }}>
                                <tr>
                                  <th>{langPreference?.boq_no || "S.No"}</th>
                                  <th>{langPreference?.boq_item_description || "Name and Details"}</th>
                                  <th>{langPreference?.rate || "Rate"} (₹)</th>
                                  <th>{langPreference?.total_quantity || "Qty"}</th>
                                  <th>{langPreference?.withhold_quantity || "with hold Qty"}</th>
                                  <th>{langPreference?.net_quantity || "Net Quantity"}</th>
                                  <th>{langPreference?.net_amount || "Net Amount"} (₹)</th>
                                </tr>
                              </thead>
                              <tbody className=''>
                                {billingFormik?.values?.items?.map((ele, index) => (
                                  <tr key={index} style={{ height: "50px" }}>
                                    <td><span>{billingFormik?.values?.items?.[index]?.sNo}</span></td>
                                    <td style={{ maxWidth: 300 }}><span >{billingFormik?.values?.items?.[index]?.nameAndDetails}</span></td>
                                    <td><span>{billingFormik?.values?.items?.[index]?.unitPrice}</span></td>
                                    <td><span>{billingFormik?.values?.items?.[index]?.quantity}</span></td>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        name={`items[${index}].withHoldQty`}
                                        value={billingFormik?.values?.items?.[index]?.withHoldQty}
                                        onChange={(e) => (e.target?.value?.split(".")[1]?.length < 3 || e.target?.value?.split(".")[1]?.length === undefined) && handleChange(e, index, ele, "number")}
                                        onBlur={billingFormik.handleBlur}
                                        disabled={addLoader}
                                        style={{ height: "30px", width: "80px" }}
                                      />
                                      {billingFormik?.touched?.items?.[index]?.withHoldQty && billingFormik?.errors?.items?.[index]?.withHoldQty ? (<div className='req-error'>{billingFormik?.errors?.items?.[index]?.withHoldQty}</div>) : null}
                                    </td>
                                    <td><span>{ele?.netQty}</span></td>
                                    <td><span>{ele?.netAmt}</span></td>
                                  </tr>))}

                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <button className='d-none' id="submitModalBtn1" data-bs-toggle="modal" data-bs-target={`#${submitConfirmModal}`} />
          <ConfirmationModal modalId={submitConfirmModal} handleConfirm={() => handleConfirmation(false)} message={langPreference?.submit_confirmation || <>Are you sure you want to <br /> Submit ?</>} />
          <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
          <StatusModal
            modalId={statusModalId}
            message={confirmationMsg}
            handleClose={handleApprovalModalClose}
          />
          {/* <button className='d-none' id="saveAndUploadConfirmModal" data-bs-toggle="modal" data-bs-target={`#${saveAndUploadConfirmModal}`} />
          <StatusModal
            modalId={saveAndUploadConfirmModal}
            message={langPreference?.uploaded_success || 'Uploaded successfully, click on "Submit for approval"'}
            handleClose={() => {
              if (id != billingFormik?.values?._id) {
                navigate(`/boq/update/${billingFormik?.values?._id}`)
              } else {
                window.location.reload()
              }
            }}
          /> */}
          <button className='d-none' id="reUploadConfirmModal" data-bs-toggle="modal" data-bs-target={`#${reUploadConfirmModal}`} />
          <ConfirmationModal modalId={reUploadConfirmModal} handleConfirm={() => { fileRef.current.click() }} message={langPreference?.earlier_billing_summary_deleted || 'Earlier Billing summary will be deleted'} />
        </div>
      </>}

    </>
  )
}

export default CreateOrUpdateFinalBill
